import { render, staticRenderFns } from "./LogworkTableBody.vue?vue&type=template&id=3d28489b&"
import script from "./LogworkTableBody.vue?vue&type=script&lang=js&"
export * from "./LogworkTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports